import React from "react";
interface BookLocationHeaderProps {
  text: string;
}

const BookLocationHeader = ({ text }: BookLocationHeaderProps) => {
  return (
    <h1 className="font-semibold text-foreground/90 text-2xl leading-[28px] text-center tracking-[-0.015em]">
      {text}
    </h1>
  );
};

export default BookLocationHeader;
